module.exports = __webpack_public_path__ + "img/ViveHandBrace.ab915e02.png";